import {IComponentOptions, ILogService, IPromise} from 'angular';
import {getTSVersicherungsbeitragStatusalues, TSVersicherungsbeitragStatus} from '../../../models/enums/TSVersicherungsbeitragStatus';
import TSVersicherungsbeitraegeSearchresultDTO from '../../../models/TSVersicherungsbeitraegeSearchresultDTO';
import TSVersicherungsbeitragDTO from '../../../models/TSVersicherungsbeitragDTO';

let template = require('./dv-versicherungsbeitrag-list.html');
require('./dv-versicherungsbeitrag-list.scss');
let removeDialogTemplate = require('../../../core/dialog/removeDialogTemplate.html');

export class DVVersicherungsbeitragListConfig implements IComponentOptions {
    transclude = false;

    bindings: any = {
        onFilterChange: '&',
        onEdit: '&',
    };
    template = template;
    controller = DVVersicherungsbeitragListController;
    controllerAs = 'vm';
}

export class DVVersicherungsbeitragListController {

    selectedBesitzer: string;

    displayedCollection: Array<TSVersicherungsbeitragDTO> = []; //Liste die im Gui angezeigt wird
    pagination: any;

    onFilterChange: (changedTableState: any) => IPromise<any>;
    onEdit: (paramObj: any) => void;

    tableFilterState: any;

    defaultTableFilterState: any = {
        sort: {},
        search: {},
        pagination: {start: 0, totalItemCount: 0, number: 30}
    };

    static $inject: any[] = ['$log', 'CONSTANTS'];

    /* @ngInject */
    constructor(private $log: ILogService, private CONSTANTS: any) {
        this.initViewModel();
    }

    private initViewModel() {

    }

    $onInit() {

    }

    private callServer = (tableFilterState: any) => {
        this.tableFilterState = tableFilterState;

        this.pagination = tableFilterState.pagination;

        if (this.onFilterChange && angular.isFunction(this.onFilterChange)) {
            this.onFilterChange({
                tableState: tableFilterState
            }).then((result: TSVersicherungsbeitraegeSearchresultDTO) => {
                if (result) {
                    tableFilterState.pagination.totalItemCount = result.totalResultSize;
                    tableFilterState.pagination.numberOfPages = Math.ceil(result.totalResultSize / tableFilterState.pagination.number);
                    this.displayedCollection = new Array<TSVersicherungsbeitragDTO>().concat(result.versicherungsbeitragDTOs);
                }
            });
        } else {
            this.$log.info('no callback function spcified for filtering');
        }
    };

    editClicked(versicherungsBeitragFallDTO: any, event: any) {
        this.onEdit({versicherungsbeitrag: versicherungsBeitragFallDTO, event: event});
    }

    public getColumnsNumber(): number {
        let element = angular.element('.dv-versicherungsbeitrag-list .header-row').first();
        if (element && element.get(0)) {
            return element.get(0).childElementCount;
        }
        //could not determine actual number, just returing an approximation
        return 7;
    }

    public getVersicherungsbeitraegeStatus(): TSVersicherungsbeitragStatus[] {
        return getTSVersicherungsbeitragStatusalues()
    }

}



// WEBPACK FOOTER //
// ./src/app/core/component/dv-versicherungsbeitrag-list/dv-versicherungsbeitrag-list.ts